import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { Theme } from './../../../api/models/theme.model';

export const themesAdapter: EntityAdapter<Theme> = createEntityAdapter<Theme>({
    selectId: (theme: Theme) => theme.Id
});

export interface ThemeState extends EntityState<Theme> {
    ids: number[];
    entities: any;
    total: number;
    loaded: boolean;
    newlyCreatedTheme: Theme;
}

